import { useMutation } from '@tanstack/react-query';
import { toast } from 'sonner';
import messageTemplatesApi from '@/features/dashboard/messageTemplates/api/messageTemplatesApi.ts';
import useUpdateMessageTemplate from '@/features/dashboard/messageTemplates/hooks/useUpdateMessageTemplate.ts';
import { MessageTemplateDto } from '@/features/dashboard/messageTemplates/types/MessageTemplateDto.ts';

/**
 * Przywrócenie domyślnej treści zapisuje ją od razu: GET po wzorzec, po nim ten
 * sam PUT, który wysyła edytor — dlatego idzie przez `useUpdateMessageTemplate`,
 * żeby unieważnienie cache i komunikat sukcesu zostały w jednym miejscu.
 * Błąd zapisu obsługuje już tamten hook, tu zgłaszamy tylko nieudany GET.
 */
const useRestoreDefaultMessageTemplate = () => {
  const updateTemplate = useUpdateMessageTemplate();

  return useMutation({
    mutationFn: async (template: MessageTemplateDto) => {
      const defaultTemplate = await messageTemplatesApi
        .getDefaultTemplate(template.channel, template.messageTemplateType)
        .catch((error: Error) => {
          toast.error('Nie udało się pobrać domyślnej treści szablonu', {
            description: error.message,
          });
          throw error;
        });

      return updateTemplate.mutateAsync({
        ...template,
        subjectTemplate: defaultTemplate.subjectTemplate,
        bodyTemplate: defaultTemplate.bodyTemplate,
      });
    },
  });
};

export default useRestoreDefaultMessageTemplate;
